import React, {useContext, useEffect, useState} from "react";
import cn from "classnames";
import styles from "./Control.module.sass";
import Checkout from "./Checkout";
import Accept from "./Accept";
import PutSale from "../../../components/PutSale";
import SuccessfullyPurchased from "./SuccessfullyPurchased";
import Modal from "../../../components/Modal";
import {Web3Context} from "../../../contexts/Web3Context";
import PlaceABid from "../../../components/PlaceABid";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";

const Control = ({className, token}) => {
  const [visibleModalPurchase, setVisibleModalPurchase] = useState(false);
  const [visibleModalAccept, setVisibleModalAccept] = useState(false);
  const [visibleModalSale, setVisibleModalSale] = useState(false);
  const [isOwner, setIsOwner] = useState(false);

  const {defaultAccount, isConnected, isCorrectNetwork} = useContext(Web3Context);

  const shareUrl = window.location.href;
  const shareTitle = token.name;

  useEffect(() => {
    if (token) {
      setIsOwner(token.currentOwner === defaultAccount);
    }
  }, [token, defaultAccount])

  return (
    <>
      <div className={cn(styles.control, className)}>
        <div className={styles.btns}>
          {token && token.in_sale != null &&
          <PlaceABid className="button-stroke" item={token} users={token.users}/>
          }
          <a href='/search' className={cn("button-stroke", styles.button)}>
            View all
          </a>
        </div>
        {isOwner && isConnected && isCorrectNetwork && token.in_sale == null && (
          <>
            <div className={styles.foot}>
              <button
                className={cn("button", styles.button)}
                onClick={() => setVisibleModalSale(true)}
              >
                Put on sale
              </button>
            </div>
            <div className={styles.note}>
              You can sell this token on {process.env.REACT_APP_TITLE} Marketplace
            </div>
          </>
        )}

        <div className={styles.share_section}>
          Share to Social Networks

          <div className={styles.share_buttons}>
            <FacebookShareButton
              url={shareUrl}
              quote={shareTitle}
              className={styles.share_icon}
            >
              <FacebookIcon size={32} round/>
            </FacebookShareButton>

            <TwitterShareButton
              url={shareUrl}
              title={shareTitle}
              className={styles.share_icon}
            >
              <TwitterIcon size={32} round/>
            </TwitterShareButton>

            <TelegramShareButton
              url={shareUrl}
              title={shareTitle}
              className={styles.share_icon}
            >
              <TelegramIcon size={32} round/>
            </TelegramShareButton>

            <WhatsappShareButton
              url={shareUrl}
              title={shareTitle}
              separator=":: "
              className={styles.share_icon}
            >
              <WhatsappIcon size={32} round/>
            </WhatsappShareButton>

            <LinkedinShareButton url={shareUrl} className={styles.share_icon}>
              <LinkedinIcon size={32} round/>
            </LinkedinShareButton>

            <EmailShareButton
              url={shareUrl}
              subject={shareTitle}
              body="body"
              className={styles.share_icon}
            >
              <EmailIcon size={32} round/>
            </EmailShareButton>
          </div>
        </div>
      </div>
      <Modal
        visible={visibleModalPurchase}
        onClose={() => setVisibleModalPurchase(false)}
      >
        <Checkout/>
        <SuccessfullyPurchased/>
      </Modal>
      <Modal
        visible={visibleModalAccept}
        onClose={() => setVisibleModalAccept(false)}
      >
        <Accept onOutsideClick={() => setVisibleModalAccept(false)}/>
      </Modal>
      <Modal
        visible={visibleModalSale}
        onClose={() => setVisibleModalSale(false)}
        onClickOutside={() => {
        }}
      >
        <PutSale item={token} onOutsideClick={() => setVisibleModalSale(false)}/>
      </Modal>
    </>
  );
}

export default Control;
